import React, { useState, useEffect } from "react";
import ControlPanel from "./ControlPanel";
import styles from "./Bot.module.css";
import Header from "./Header";
import ChatArea from "./ChatArea";
import {setupLiveApi, toggleStream, closeStreaming} from "../../live-api"

const Bot = ({ userInfo, onClose }) => {
    const [showMessage, setShowMessage] = useState(false);
    const [error, setError] = useState(null);
    const [view, setView] = useState("initial");
    const [callStatus, setCallStatus] = useState("no-call");    


    function showMessages(){
        if(showMessage)
            setView('initial');
        else
            setView('chat');
        setShowMessage(!showMessage);
    }

    function startCallHandler(){
      toggleStream()
      .then(() => {
        setCallStatus("ready");
        console.log("ready");
      })
      .catch((err) => {
        console.log(err);
        setError(err);
        setCallStatus("no-call");
      })
    }

    function finishCall(){
      closeStreaming();
      setCallStatus("no-call");
      setView('final');
    }

    useEffect(() => {
      setupLiveApi();
      return closeStreaming;
    }, []);
  return (
    <div className={styles.bot}>
      {/* Header */}
      <Header onClose={onClose} />

      <ChatArea email={userInfo.username} firstName={userInfo.name.split(" ")[0]} noHandler={onClose} view={view} error={error} setView={setView} callStatus={callStatus} setCallStatus={setCallStatus} startCallHandler={startCallHandler}/>

      {/* Control Panel */}
      <ControlPanel showMessages={showMessages} callStatus={callStatus} finishCallHandler={finishCall} />
    </div>
  );
};

export default Bot;
